
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ActiveIcon from '@mui/icons-material/Check';
import InactiveIcon from '@mui/icons-material/Close';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';

import Paper from '@mui/material/Paper';
import { MobileSubscription } from '../../interface/MobileSubscription';
import moment from "moment"

interface SubscriptionsListProps
{   
    subscriptions: MobileSubscription[]
    onEdit: (item: MobileSubscription) => void
}

export const SubscriptionsList = ({ subscriptions, onEdit }: SubscriptionsListProps) => {

    return (

     <TableContainer component={Paper} style={{ overflow: "auto", height: "80vh"}}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell >Active</TableCell>
            <TableCell>User</TableCell>
            <TableCell align="right">ProductId</TableCell>
            <TableCell align="right">Creation time</TableCell>
            <TableCell align="right">Last bill date</TableCell>
            <TableCell align="right">Next bill date</TableCell>
            <TableCell align="right">Last updated</TableCell>
            <TableCell align="right">Platform</TableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {subscriptions?.map((row) => (
            <TableRow
              onClick={() => onEdit(row)}
              hover
              key={row._id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
             <TableCell component="th" scope="row" align="left">{row.isActive ? <ActiveIcon color="success" /> : <InactiveIcon color="error" />}</TableCell>
              <TableCell >
                {row.email}
              </TableCell>
              <TableCell align="right">{row.productId}</TableCell>
              <TableCell align="right">{moment(row.createdAt).fromNow()}</TableCell>
              <TableCell align="right">{row.lastBillDate ? moment(row.lastBillDate).fromNow() : "-"}</TableCell>
              <TableCell align="right">{row.nextBillDate ? moment(row.nextBillDate).fromNow() : "-"}</TableCell>
              <TableCell align="right">{row.lastUpdated ? moment(row.lastUpdated).fromNow() : "never"}</TableCell>
              <TableCell align="right">{row.androidPurchaseToken ? <AndroidIcon /> : <AppleIcon />}</TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    )
}